import { LuInfo } from 'react-icons/lu'
import { Card, Flex, Icon, Text } from '@chakra-ui/react'

import { useTranslation } from '~/lib/i18n'
import { theme } from '~/styles/theme'

interface Props {
  showUnclaimedRewardsDisclaimer?: boolean
}

const StakeWithdrawDisclaimer = ({ showUnclaimedRewardsDisclaimer }: Props) => {
  const { t } = useTranslation('staking')

  return (
    <Card
      justifyContent="center"
      w={{ base: '100%' }}
      alignItems={{ base: 'flex-start' }}
      background={theme.colors.background.box}
      border="1px solid #FFFFFF12"
      borderRadius="10px"
      p={4}
    >
      <Flex gap={4} alignItems="flex-start">
        <Icon as={LuInfo} w={5} h={5} color={theme.colors.text.alternative} mt={0.5} />
        <Flex direction="column" gap={1}>
          <Text fontWeight="bold" fontSize="16px" lineHeight="24px" color={theme.colors.text.alternative}>
            {t('modal.disclaimer.title')}
          </Text>
          <Text fontWeight="medium" fontSize="14px" lineHeight="20px" color={theme.colors.text.secondary}>
            {t('modal.disclaimer.description')}
          </Text>
          {showUnclaimedRewardsDisclaimer && (
            <Text fontWeight="medium" fontSize="14px" lineHeight="20px" color={theme.colors.text.secondary} mt="-1">
              {t('modal.disclaimer.unclaimedRewardsDescription')}
            </Text>
          )}
        </Flex>
      </Flex>
    </Card>
  )
}

export default StakeWithdrawDisclaimer
